export const CREATE_PROFILE_DATA = [
	{
		title: {
			es: "Crea tu perfil",
			en: "Create your profile",
		},
		description: {
			es: 'Ve a la pestaña <strong>"Mi cuenta"</strong> y selecciona <strong>"Crear perfil"</strong> para iniciar el proceso.',
			en: 'Go to the <strong>"My account"</strong> tab and select <strong>"Create profile"</strong> to start the process.',
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/crear-perfil_1.png",
			en: "/img/personal-account/tutorial/en/crear-perfil_1.png",
		},
	},
	{
		title: {
			es: "Registra tus datos",
			en: "Register your information",
		},
		description: {
			es: "Ingresa tu correo electrónico y una contraseña para continuar.",
			en: "Enter your email address and a password to continue.",
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/crear-perfil_2.png",
			en: "/img/personal-account/tutorial/en/crear-perfil_2.png",
		},
	},
	{
		title: {
			es: "Verifica tu correo electrónico",
			en: "Verify your email address",
		},
		description: {
			es: "Revisa tu bandeja de entrada o la carpeta de spam e ingresa el código para validar tu cuenta.",
			en: "Check your inbox (or spam folder) and enter the code to validate your profile.",
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/crear-perfil_3.png",
			en: "/img/personal-account/tutorial/en/crear-perfil_3.png",
		},
	},
	{
		title: {
			es: "Completa tu perfil",
			en: "Complete your profile",
		},
		description: {
			es: 'Llena la información adicional solicitada. Cuando termines, haz clic en <strong>"Finalizar"</strong>.',
			en: 'Fill out the requested additional information. When you are finished, click <strong>"Finish"</strong>.',
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/crear-perfil_4.png",
			en: "/img/personal-account/tutorial/en/crear-perfil_4.png",
		},
	},
	{
		title: {
			es: "Accede a la plataforma",
			en: "Access the platform",
		},
		description: {
			es: 'Verás un mensaje de bienvenida. Haz clic en <strong>"Empezar a leer"</strong> para ingresar y disfrutar de tus libros.',
			en: 'You will see a welcome message. Select <strong>"Start reading"</strong> to log in and begin enjoying your books.',
		},
		imageUrl: {
			es: "/img/personal-account/tutorial/es/crear-perfil_5.png",
			en: "/img/personal-account/tutorial/en/crear-perfil_5.png",
		},
	},
];
